import * as React from 'react';
import styles from '../../styles/flyouts/substages/Properties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router-dom';
import {
  __,
  setTableParams,
  validateForm,
  getURLParam,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import classNames from 'classnames';
import EditSubstageForm from '../../forms/substages/EditSubstageForm';
import {
  listProjectStages,
  readStage,
  updateStage,
} from '../../redux/actions/table/stages';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import {
  readSubstage,
  updateSubstage,
} from '../../redux/actions/table/substages';
import { connect } from 'react-redux';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual';

const Properties = ({
  data,
  collapsed,
  is_project_administrator,
  match,
  localization,
  readAction,
  auth,
}) => {
  const handleSubmit = (formData) => {
    formData = {
      ...formData,

      date: {
        ...data?.date,
        ...formData?.date,
      },
    };

    return validateForm(
      updateSubstage(formData.id, _.omit(formData, ['id'])).then(() => {
        readAction(formData.id);

        listActiveModules();

        setNotification(__('project.substages.notification.saved'));
      })
    );
  };

  const application_languages = _.transform(
    _.filter(
      localization.languages,
      (language) => language.application_language == true
    ),
    (languages, language) => {
      languages[language.id] = language.id == auth.language_id;
      return languages;
    },
    {}
  );

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      <EditSubstageForm
        isProjectAdministrator={is_project_administrator}
        onSubmit={handleSubmit}
        initialValues={{
          ..._.pick(data, ['id', 'name', 'description', 'status']),
          date: {
            start: data?.date?.start,
            end: data?.date?.end,
            allDay: data?.date?.allDay,
            duration: data?.date?.duration,
            deadline: data?.date?.deadline,
            deadline_date: data?.date?.deadline_date,
          },
          time_log: {
            planned_time: data?.time_log?.planned_time,
          },
        }}
        projectLanguages={data?.languages}
        // application_languages={application_languages}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: _.get(state, 'auth'),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(Properties))
);
